import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import InsulatedLayer from "../../components/Insulated/InsulatedLayer";


const InsulatedList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Insulated" />

        {/* UsersListLayer */}
        <InsulatedLayer />

      </MasterLayout>

    </>
  );
};

export default InsulatedList; 
